import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '@Environments/environment';
import { GeneralApiEndpoints } from '@AppCore/constants/api-endpoints';
import { GlobalUtilityService } from '@AppCore/services/global-utility.service';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { LocalStorageDataModel } from '@AppCore/constants/local-storage-data-model';
import { HttpHelperService } from '@AppCore/services/http-helper.service';

import {
  LoginWithOtp,
  LoginWithPassword,
  SignUp,
} from '@AppRoot/shared/models/login-signup.interface';
import { APIResponse } from '@AppRoot/shared/models/api-response.interface';
import { SharedService } from '@AppRoot/shared/services/shared.service';
import { ErrorHandlerService } from '@AppCore/services/global-error-handler.service';
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private http: HttpHelperService,
    private globalUtilityService: GlobalUtilityService,
    private _sharedService: SharedService,
    private errorHandlerService: ErrorHandlerService
  ) {}

  getLoginStatus(): Observable<any> {
    const url = `${environment.BASE_URL}${GeneralApiEndpoints.LOGIN_STATUS}`;
    return this.http.get(url);
  }

  register(data: SignUp) {
    const url = `${environment.BASE_URL}${GeneralApiEndpoints.SIGNUP}`;
    return this.http.post(url, data).pipe(
      tap((response: APIResponse) => {
        this.globalUtilityService.setDataOnLocalStorage(
          LocalStorageDataModel.AUTH_KEY,
          response.data.token
        );
      }),
      catchError((error: any) => {
        return throwError(() => new Error(error.message || 'Login failed'));
      })
    );
  }

  loginWithPassword(data: LoginWithPassword) {
    const url = `${environment.BASE_URL}${GeneralApiEndpoints.LOGINWITHPASSWORD}`;

    return this.http.post(url, data).pipe(
      tap({
        next: (response: APIResponse) => {
          if (response?.data?.user && response?.data?.token) {
            // Store user data and token
            this.globalUtilityService.setLoginStatus(true);
            this.globalUtilityService.setUserData(response.data.user);
            this.globalUtilityService.setDataOnLocalStorage(
              LocalStorageDataModel.AUTH_KEY,
              response.data.token
            );

            this.globalUtilityService.showToast(
              'success',
              'Congratulation you Logged in successfully'
            );
          } else {
            throw new Error('Unexpected response format.');
          }
        },
      }),
      catchError((error: any) => {
        return this.errorHandlerService.handleError(error);
      })
    );
  }

  loginWithOtp(otp: string, phone: string) {
    const url = `${environment.BASE_URL}${GeneralApiEndpoints.LOGINWITHOTP}`;

    return this.http.post(url, { otp, phone }).pipe(
      tap({
        next: (response: APIResponse) => {
          if (response?.data?.user && response?.data?.token) {
            // Store user data and token
            this.globalUtilityService.setLoginStatus(true);
            this.globalUtilityService.setUserData(response.data.user);
            this.globalUtilityService.setDataOnLocalStorage(
              LocalStorageDataModel.AUTH_KEY,
              response.data.token
            );
          }
        },
      }),
      catchError((error: any) => {
        this.globalUtilityService.hideLoader();
        this.globalUtilityService.showToast(
          'Error',
          'Unable to login Right now! Please Try again'
        );
        throw new Error(error);
      })
    );
  }

  forgotPassword(username: string) {
    const url = `${environment.BASE_URL}${GeneralApiEndpoints.FORGOT_PASSWORD}`;
    return this.http.post(url, { username }).pipe(
      catchError((error: any) => {
        throw new Error(error);
      })
    );
  }

  resetPassword(data: { username: string; password: string; otp: string }) {
    const url = `${environment.BASE_URL}${GeneralApiEndpoints.RESET_PASSWORD}`;
    return this.http.post(url, data).pipe(
      catchError((error: any) => {
        throw new Error(error);
      })
    );
  }

  sendOtp(username: string) {
    const url = `${environment.BASE_URL}${GeneralApiEndpoints.SENDOTP}`;
    return this.http.post(url, { username }).pipe(
      catchError((error: any) => {
        throw new Error(error);
      })
    );
  }
}
